import { useState } from 'react';

interface KnowledgeItem {
  id: number;
  title: string;
  category: string;
  content: string;
  image: string;
  tags: string[];
  difficulty: 'beginner' | 'intermediate' | 'advanced';
}

const knowledgeData: KnowledgeItem[] = [
  {
    id: 1,
    title: 'バラの特徴と育て方',
    category: '春の花',
    content: 'バラは「花の女王」と呼ばれ、世界中で愛されている花です。品種は2万種以上あり、色や形、香りも様々です。日当たりの良い場所を好み、水はけの良い土壌で育てます。春と秋に美しい花を咲かせ、定期的な剪定と肥料で長く楽しめます。病害虫対策として、風通しを良くすることが重要です。',
    image: 'https://public.readdy.ai/ai/img_res/3e43dba93efeeb712894fca163c11268.jpg',
    tags: ['バラ', '春', '育て方'],
    difficulty: 'intermediate'
  },
  {
    id: 2,
    title: 'チューリップの魅力と栽培方法',
    category: '春の花',
    content: 'チューリップは春を代表する球根植物で、オランダが有名な産地です。秋に球根を植え付け、春に開花します。色のバリエーションが豊富で、赤、黄、ピンク、白、紫など様々な色があります。日当たりと水はけの良い場所を好み、寒さに強い特徴があります。切り花としても人気が高く、花瓶に生けると1週間程度楽しめます。',
    image: 'https://readdy.ai/api/search-image?query=colorful%20tulips%20field%20in%20spring%2C%20red%20yellow%20pink%20tulips%20in%20rows%2C%20dutch%20flower%20garden%2C%20bright%20sunny%20day%2C%20vibrant%20botanical%20photography&width=400&height=300&seq=flower2&orientation=landscape',
    tags: ['チューリップ', '球根', '春'],
    difficulty: 'beginner'
  },
  {
    id: 3,
    title: 'ひまわりの特徴と栽培ポイント',
    category: '夏の花',
    content: 'ひまわりは夏を象徴する大型の花で、太陽に向かって咲く姿が印象的です。種から簡単に育てられ、初心者にもおすすめです。草丈は品種により50cm～3mと幅広く、庭のシンボルツリーとしても人気です。日当たりと水はけの良い場所で、たっぷりの水と肥料を与えると大きく育ちます。種は食用やペットの餌としても利用できます。',
    image: 'https://readdy.ai/api/search-image?query=giant%20sunflowers%20facing%20sun%20in%20summer%20field%2C%20bright%20yellow%20petals%2C%20blue%20sky%20background%2C%20cheerful%20botanical%20photography%2C%20warm%20sunlight&width=400&height=300&seq=flower3&orientation=landscape',
    tags: ['ひまわり', '夏', '大型'],
    difficulty: 'beginner'
  },
  {
    id: 4,
    title: 'アジサイの色変化と育て方',
    category: '梅雨の花',
    content: 'アジサイは梅雨時期を彩る代表的な花で、土壌のpH値によって花色が変化する特徴があります。酸性土壌では青色、アルカリ性土壌では赤色になります。半日陰を好み、水を好む植物なので、夏場は朝夕の水やりが必要です。剪定は花後すぐに行うと、翌年も美しい花を楽しめます。切り花やドライフラワーとしても人気があります。',
    image: 'https://readdy.ai/api/search-image?query=blue%20and%20pink%20hydrangea%20flowers%20in%20rainy%20season%20garden%2C%20water%20droplets%20on%20petals%2C%20lush%20green%20leaves%2C%20soft%20misty%20atmosphere%2C%20beautiful%20botanical%20photography&width=400&height=300&seq=flower4&orientation=landscape',
    tags: ['アジサイ', '梅雨', 'pH'],
    difficulty: 'intermediate'
  },
  {
    id: 5,
    title: 'コスモスの特徴と栽培方法',
    category: '秋の花',
    content: 'コスモスは秋の風物詩として親しまれている花で、ピンク、白、赤などの可憐な花を咲かせます。種まきから簡単に育てられ、痩せた土地でも元気に育つ丈夫な植物です。草丈は1～2mになり、風に揺れる姿が美しいです。日当たりの良い場所を好み、水はけの良い土壌で育てます。切り花としても長持ちし、秋の花束に最適です。',
    image: 'https://readdy.ai/api/search-image?query=pink%20cosmos%20flowers%20swaying%20in%20autumn%20breeze%2C%20delicate%20petals%2C%20blue%20sky%20background%2C%20peaceful%20meadow%2C%20soft%20natural%20lighting%2C%20romantic%20botanical%20photography&width=400&height=300&seq=flower5&orientation=landscape',
    tags: ['コスモス', '秋', '簡単'],
    difficulty: 'beginner'
  },
  {
    id: 6,
    title: 'ラベンダーの香りと育て方',
    category: '香りの花',
    content: 'ラベンダーは紫色の花穂と爽やかな香りが特徴のハーブです。リラックス効果があり、アロマテラピーやポプリに利用されます。地中海原産で、日当たりと風通しの良い場所を好みます。水はけの良い土壌で育て、過湿を避けることが重要です。開花期は初夏で、ドライフラワーにしても香りが長持ちします。',
    image: 'https://readdy.ai/api/search-image?query=purple%20lavender%20field%20in%20bloom%2C%20rows%20of%20fragrant%20flowers%2C%20provence%20style%20garden%2C%20bees%20gathering%20nectar%2C%20peaceful%20countryside%2C%20aromatic%20botanical%20photography&width=400&height=300&seq=flower6&orientation=landscape',
    tags: ['ラベンダー', '香り', 'ハーブ'],
    difficulty: 'intermediate'
  },
  {
    id: 7,
    title: '桜の種類と鑑賞ポイント',
    category: '春の花',
    content: '桜は日本を代表する花で、春の訪れを告げる象徴です。ソメイヨシノが最も有名ですが、山桜、八重桜、しだれ桜など多くの品種があります。開花期間は約1週間と短く、満開から散るまでの美しさが日本人の心を捉えています。日当たりの良い場所を好み、剪定は最小限にすることが健康な成長のポイントです。',
    image: 'https://readdy.ai/api/search-image?query=cherry%20blossom%20sakura%20trees%20in%20full%20bloom%2C%20pink%20petals%20falling%2C%20spring%20festival%20atmosphere%2C%20traditional%20japanese%20garden%2C%20soft%20pink%20lighting%2C%20romantic%20botanical%20photography&width=400&height=300&seq=flower7&orientation=landscape',
    tags: ['桜', '春', '日本'],
    difficulty: 'beginner'
  },
  {
    id: 8,
    title: 'カーネーションの特徴と管理',
    category: '通年の花',
    content: 'カーネーションは母の日の花として有名で、フリルのような花びらが特徴です。赤、ピンク、白、黄色など色が豊富で、それぞれに花言葉があります。切り花として非常に長持ちし、2週間以上楽しめます。日当たりの良い場所を好み、水はけの良い土壌で育てます。定期的な摘心で枝数を増やし、たくさんの花を咲かせることができます。',
    image: 'https://readdy.ai/api/search-image?query=pink%20carnation%20flowers%20with%20ruffled%20petals%2C%20mothers%20day%20bouquet%2C%20elegant%20floral%20arrangement%2C%20soft%20lighting%2C%20beautiful%20botanical%20photography&width=400&height=300&seq=flower8&orientation=landscape',
    tags: ['カーネーション', '母の日', '長持ち'],
    difficulty: 'beginner'
  },
  {
    id: 9,
    title: 'ユリの種類と育て方',
    category: '夏の花',
    content: 'ユリは大輪で華やかな花を咲かせる球根植物です。オリエンタル系、アジアティック系、カサブランカなど多くの品種があります。強い香りを持つ品種も多く、切り花として人気があります。日当たりの良い場所を好みますが、根元は日陰を好むため、マルチングや低木との混植がおすすめです。秋に球根を植え付け、初夏に開花します。',
    image: 'https://readdy.ai/api/search-image?query=white%20oriental%20lily%20flowers%20in%20bloom%2C%20large%20elegant%20petals%2C%20sweet%20fragrance%2C%20summer%20garden%2C%20sophisticated%20botanical%20photography%2C%20soft%20natural%20lighting&width=400&height=300&seq=flower9&orientation=landscape',
    tags: ['ユリ', '球根', '香り'],
    difficulty: 'intermediate'
  },
  {
    id: 10,
    title: 'パンジーとビオラの違いと育て方',
    category: '冬の花',
    content: 'パンジーとビオラは冬から春にかけて咲く貴重な花です。パンジーは花が大きく、ビオラは小さめで花数が多いのが特徴です。寒さに強く、霜にも耐えられます。日当たりの良い場所を好み、定期的な花がら摘みで長期間開花します。色のバリエーションが豊富で、寄せ植えやハンギングバスケットに最適です。',
    image: 'https://readdy.ai/api/search-image?query=colorful%20pansy%20and%20viola%20flowers%20in%20winter%20garden%2C%20purple%20yellow%20white%20blooms%2C%20frost%20resistant%20plants%2C%20cheerful%20botanical%20photography%2C%20bright%20colors&width=400&height=300&seq=flower10&orientation=landscape',
    tags: ['パンジー', 'ビオラ', '冬'],
    difficulty: 'beginner'
  },
  {
    id: 11,
    title: 'スイートピーの特徴と栽培',
    category: '春の花',
    content: 'スイートピーは甘い香りとパステルカラーの花が魅力的なつる性植物です。春に咲く花は切り花として人気があり、ブーケやアレンジメントによく使われます。日当たりと風通しの良い場所を好み、支柱やネットに絡ませて育てます。秋に種をまき、春に開花します。香りの良い品種を選ぶと、庭全体が甘い香りに包まれます。',
    image: 'https://readdy.ai/api/search-image?query=sweet%20pea%20flowers%20in%20pastel%20colors%2C%20delicate%20blooms%20on%20climbing%20vines%2C%20fragrant%20spring%20flowers%2C%20romantic%20garden%20setting%2C%20soft%20botanical%20photography&width=400&height=300&seq=flower11&orientation=landscape',
    tags: ['スイートピー', '香り', 'つる性'],
    difficulty: 'intermediate'
  },
  {
    id: 12,
    title: 'マリーゴールドの効果と育て方',
    category: '夏の花',
    content: 'マリーゴールドは鮮やかなオレンジや黄色の花を咲かせる丈夫な植物です。コンパニオンプランツとして有名で、根から分泌される物質が害虫を遠ざけます。野菜の近くに植えると、アブラムシやセンチュウの被害を減らせます。日当たりの良い場所を好み、種から簡単に育てられます。夏から秋まで長期間開花し、花壇を明るく彩ります。',
    image: 'https://readdy.ai/api/search-image?query=orange%20and%20yellow%20marigold%20flowers%20in%20vegetable%20garden%2C%20companion%20planting%2C%20bright%20cheerful%20blooms%2C%20summer%20garden%2C%20vibrant%20botanical%20photography&width=400&height=300&seq=flower12&orientation=landscape',
    tags: ['マリーゴールド', '害虫対策', '夏'],
    difficulty: 'beginner'
  }
];

const categories = ['すべて', '春の花', '夏の花', '秋の花', '冬の花', '梅雨の花', '香りの花', '通年の花'];
const difficulties = ['すべて', 'beginner', 'intermediate', 'advanced'];

const difficultyLabels = {
  beginner: '初級',
  intermediate: '中級',
  advanced: '上級'
};

const difficultyColors = {
  beginner: 'bg-green-100 text-green-800',
  intermediate: 'bg-yellow-100 text-yellow-800',
  advanced: 'bg-red-100 text-red-800'
};

export default function Knowledge() {
  const [selectedCategory, setSelectedCategory] = useState('すべて');
  const [selectedDifficulty, setSelectedDifficulty] = useState('すべて');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedKnowledge, setSelectedKnowledge] = useState<KnowledgeItem | null>(null);

  const filteredKnowledge = knowledgeData.filter(item => {
    const matchesCategory = selectedCategory === 'すべて' || item.category === selectedCategory;
    const matchesDifficulty = selectedDifficulty === 'すべて' || item.difficulty === selectedDifficulty;
    const matchesSearch = item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.content.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    
    return matchesCategory && matchesDifficulty && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-green-600 via-emerald-600 to-teal-600 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-flower-line text-4xl"></i>
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">花の特徴</h1>
          <p className="text-xl text-green-100 max-w-2xl mx-auto">
            様々な花の特徴、育て方、見頃を学んで、美しい花のある暮らしを楽しみましょう
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        {/* Filters */}
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Search */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">検索</label>
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                <input
                  type="text"
                  placeholder="花の特徴を検索..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            {/* Category Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">カテゴリー</label>
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm pr-8"
              >
                {categories.map(category => (
                  <option key={category} value={category}>{category}</option>
                ))}
              </select>
            </div>

            {/* Difficulty Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">難易度</label>
              <select
                value={selectedDifficulty}
                onChange={(e) => setSelectedDifficulty(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm pr-8"
              >
                {difficulties.map(difficulty => (
                  <option key={difficulty} value={difficulty}>
                    {difficulty === 'すべて' ? 'すべて' : difficultyLabels[difficulty as keyof typeof difficultyLabels]}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Knowledge Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredKnowledge.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
              onClick={() => setSelectedKnowledge(item)}
            >
              <div className="relative">
                <div className="w-full h-48">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute top-4 right-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${difficultyColors[item.difficulty]}`}>
                    {difficultyLabels[item.difficulty]}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-sm text-green-600 font-medium">{item.category}</span>
                  <i className="ri-arrow-right-line text-gray-400"></i>
                </div>
                
                <h3 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2">
                  {item.title}
                </h3>
                
                <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                  {item.content}
                </p>
                
                <div className="flex flex-wrap gap-2">
                  {item.tags.slice(0, 3).map((tag, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredKnowledge.length === 0 && (
          <div className="text-center py-12">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-search-line text-3xl text-gray-400"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">花の特徴が見つかりません</h3>
            <p className="text-gray-600">検索条件を変更してお試しください</p>
          </div>
        )}
      </div>

      {/* Knowledge Detail Modal */}
      {selectedKnowledge && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              <div className="w-full h-64">
                <img
                  src={selectedKnowledge.image}
                  alt={selectedKnowledge.title}
                  className="w-full h-full object-cover rounded-t-2xl"
                />
              </div>
              <button
                onClick={() => setSelectedKnowledge(null)}
                className="absolute top-4 right-4 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
              <div className="absolute bottom-4 right-4">
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${difficultyColors[selectedKnowledge.difficulty]}`}>
                  {difficultyLabels[selectedKnowledge.difficulty]}
                </span>
              </div>
            </div>
            
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <span className="text-sm text-green-600 font-medium">{selectedKnowledge.category}</span>
              </div>
              
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {selectedKnowledge.title}
              </h2>
              
              <p className="text-gray-700 leading-relaxed mb-6">
                {selectedKnowledge.content}
              </p>
              
              <div className="flex flex-wrap gap-2">
                {selectedKnowledge.tags.map((tag, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 bg-green-100 text-green-700 text-sm rounded-full"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
